import React from 'react'
import { useTranslation } from 'react-i18next'

import { ContentStateInterface } from '../../../../../../../@types/types'
import { parseNumber } from '../../../../../../../services/validation/rules/validationFunctions'
import { NumberInput } from '../../../../../../common/inputs/numberInput/NumberInput'
import styles from './TotalRent.module.css'

type TotalRentProps = {
  insertionData: ContentStateInterface
  wrapperClassName?: string
}

export const calculateTotalRent = ({
  price,
  additionalCosts,
  heatingCosts,
  heatingCostsOption,
}: ContentStateInterface): number | undefined => {
  const coldRent = parseNumber(price)

  if (coldRent <= 0) {
    return undefined
  }

  const additionalCostsValue = Math.max(parseNumber(additionalCosts), 0)
  const separatelyChargedHeatingCosts = heatingCostsOption === false ? Math.max(parseNumber(heatingCosts), 0) : 0

  return coldRent + additionalCostsValue + separatelyChargedHeatingCosts
}

export const TotalRent: React.FC<TotalRentProps> = ({
  insertionData,
  wrapperClassName = 'grid-item one-whole margin-top-l',
}) => {
  const { t } = useTranslation()

  return (
    <div className={wrapperClassName}>
      <NumberInput
        id='calculated-total-rent'
        className={styles.disabledInput}
        propertyName='custom'
        placeholder=''
        value={calculateTotalRent(insertionData)}
        minPrecision={0}
        maxPrecision={2}
        maxLength={14}
        affixRight='unit'
        unitRight='eur'
        disabled={true}
        hideMandatorySign={true}
        errors={[]}
        doOnFieldChange={() => undefined}
        label={t('wizard.screen.costs.costCalculation.totalRent')}
      />
    </div>
  )
}
